import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography/Typography.tsx';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  BubbleImageStyles,
  OnboardingFooterContainerStyles,
  TextContainerStyles,
} from './Welcome.styles.ts';

export const Welcome: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Welcome Screen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage
      background="dark-solid"
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-maxim/welcome/background.png`}
          alt="Background"
        />
      }
    >
      <IonContent>
        <BubbleImageStyles
          src={`${S3_BUCKET_URL}/layout-own-ai-maxim/welcome/bubble.png`}
          alt=""
        />
        <OnboardingFooterContainerStyles>
          <TextContainerStyles>
            <UiTypography variant="body-large" color="white" align="center">
              I'm available for you 24/7
            </UiTypography>
          </TextContainerStyles>
          <OnboardingFooter onContinue={handleNextStep} />
        </OnboardingFooterContainerStyles>
      </IonContent>
    </OnboardingPage>
  );
};
